import { api } from '@/api';

export const getMeMutation = () => {
  return {
    mutationFn: async (params: { token: string }) => {
      try {
        const response = await api.Me(null, null, {
          headers: {
            Authorization: `Bearer ${params.token}`,
          },
        });

        return response.data;
      } catch (_error) {
        return null;
      }
    },
  };
};
